import React, { useEffect } from 'react';
import { Field, getIn, useFormikContext } from 'formik';
import { Col, Row } from 'react-bootstrap';

import { FormikNumber, FormikSelect } from '../../../components';

const SettlementDiscountForm = ({ settlement }) => {
  const { errors, touched, setFieldValue } = useFormikContext();

  useEffect(() => window.scrollTo(0, 0), []);

  return (
    <>
      <h4 className="my-4">Conceptos</h4>
      <Row className="mt-4">
        <Col sm={6} md={9}>
          <p className="font-weight-normal my-2">Préstamos</p>
        </Col>
        <Col sm={6} md={3}>
          <Field name="settlement[parsedLoanAmount]">
            {({ field }) => (
              <FormikNumber
                {...field}
                disabled
                leftAddon="$"
                label={false}
                fieldName="settlement[loanAmount]"
                value={settlement.loanAmount}
                setFieldValue={setFieldValue}
                errors={errors}
                touched={touched}
              />
            )}
          </Field>
        </Col>
      </Row>
      <Row>
        <Col sm={6} md={9}>
          <p className="font-weight-normal my-2">Anticipos</p>
        </Col>
        <Col sm={6} md={3}>
          <Field name="settlement[parsedAdvancePaymentAmount]">
            {({ field }) => (
              <FormikNumber
                {...field}
                disabled
                leftAddon="$"
                label={false}
                fieldName="settlement[advancePaymentAmount]"
                value={settlement.advancePaymentAmount}
                setFieldValue={setFieldValue}
                errors={errors}
                touched={touched}
              />
            )}
          </Field>
        </Col>
      </Row>
      <Row>
        <Col sm={6} md={9}>
          <p className="font-weight-normal my-2">Remuneraciones</p>
        </Col>
        <Col sm={6} md={3}>
          <Field name="settlement[parsedPayrollAmount]">
            {({ field }) => (
              <FormikNumber
                {...field}
                disabled
                leftAddon="$"
                label={false}
                fieldName="settlement[payrollAmount]"
                value={settlement.payrollAmount}
                setFieldValue={setFieldValue}
                errors={errors}
                touched={touched}
              />
            )}
          </Field>
        </Col>
      </Row>

      <h4 className="my-4">Otros Conceptos</h4>
      <Row>
        <Col sm={6} md={9}>
          <Field name="settlement[discount]">
            {({ field }) => (
              <FormikSelect
                {...field}
                label={false}
                placeholder="Seleccionar Descuento"
                options={[]}
                onChange={data => setFieldValue(field.name, data ? data.value : '')}
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
        <Col sm={6} md={3}>
          <Field name="settlement[parsedDiscountAmount]">
            {({ field }) => (
              <FormikNumber
                {...field}
                leftAddon="$"
                label={false}
                fieldName="settlement[discountAmount]"
                value={settlement.discountAmount}
                setFieldValue={setFieldValue}
                errors={errors}
                touched={touched}
              />
            )}
          </Field>
        </Col>
      </Row>
      <Row>
        <Col sm={6} md={9}>
          <Field name="settlement[discount]">
            {({ field }) => (
              <FormikSelect
                {...field}
                label={false}
                placeholder="Seleccionar Descuento"
                options={[]}
                onChange={data => setFieldValue(field.name, data ? data.value : '')}
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
        <Col sm={6} md={3}>
          <Field name="settlement[parsedDiscountAmount]">
            {({ field }) => (
              <FormikNumber
                {...field}
                leftAddon="$"
                label={false}
                fieldName="settlement[discountAmount]"
                value={settlement.discountAmount}
                setFieldValue={setFieldValue}
                errors={errors}
                touched={touched}
              />
            )}
          </Field>
        </Col>
      </Row>
      <Row>
        <Col sm={6} md={9}>
          <Field name="settlement[discount]">
            {({ field }) => (
              <FormikSelect
                {...field}
                label={false}
                placeholder="Seleccionar Descuento"
                options={[]}
                onChange={data => setFieldValue(field.name, data ? data.value : '')}
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
        <Col sm={6} md={3}>
          <Field name="settlement[parsedDiscountAmount]">
            {({ field }) => (
              <FormikNumber
                {...field}
                leftAddon="$"
                label={false}
                fieldName="settlement[discountAmount]"
                value={settlement.discountAmount}
                setFieldValue={setFieldValue}
                errors={errors}
                touched={touched}
              />
            )}
          </Field>
        </Col>
      </Row>
      <Row>
        <Col sm={6} md={9}>
          <Field name="settlement[discount]">
            {({ field }) => (
              <FormikSelect
                {...field}
                label={false}
                placeholder="Seleccionar Descuento"
                options={[]}
                onChange={data => setFieldValue(field.name, data ? data.value : '')}
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
        <Col sm={6} md={3}>
          <Field name="settlement[parsedDiscountAmount]">
            {({ field }) => (
              <FormikNumber
                {...field}
                leftAddon="$"
                label={false}
                fieldName="settlement[discountAmount]"
                value={settlement.discountAmount}
                setFieldValue={setFieldValue}
                errors={errors}
                touched={touched}
              />
            )}
          </Field>
        </Col>
      </Row>

      <Row className="mt-4">
        <Col sm={6} md={{ span: 3, offset: 6 }} lg={{ span: 2, offset: 7 }}>
          <h5 className="text-uppercase font-weight-bold my-2">Total Descuentos</h5>
        </Col>
        <Col sm={6} md={3}>
          <Field name="settlement[parsedTotalDiscount]">
            {({ field }) => (
              <FormikNumber
                {...field}
                disabled
                leftAddon="$"
                label={false}
                fieldName="settlement[totalDiscount]"
                value={settlement.totalDiscount}
                setFieldValue={setFieldValue}
                errors={errors}
                touched={touched}
              />
            )}
          </Field>
        </Col>
      </Row>
    </>
  );
};

export default SettlementDiscountForm;
